(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-tabs"] && !Shopify.designMode) return;
  try {
    
  function initPdpTabs(root, groupIndex) {
    if (!root || root.dataset.pdpTabsInitialized === 'true') return;

    const tabs = root.querySelector('.tabs');
    const tablist = root.querySelector('.tabs-nav.desktop');
    const items = Array.from(root.querySelectorAll('.tab-items > .item'));

    if (!tabs || !tablist || items.length === 0) return;

    root.dataset.pdpTabsInitialized = 'true';

    if (!root.id) root.id = `PdpTabsAuto-${groupIndex}`;
    if (!tablist.hasAttribute('role')) tablist.setAttribute('role', 'tablist');
    if (!tablist.hasAttribute('aria-label')) tablist.setAttribute('aria-label', 'Product information');

    const tabControls = Array.from(tablist.querySelectorAll('[role="tab"], button, h3')).slice(0, items.length);
    const panels = items.map((item) => item.querySelector('.text') || item);
    const mobileToggles = items.map((item) => item.querySelector('.mobile'));

    if (tabControls.length === 0) return;

    function isEnterOrSpace(event) {
      return event.key === 'Enter' || event.key === ' ';
    }

    function getActiveIndex() {
      const selectedIndex = tabControls.findIndex((control) => control.getAttribute('aria-selected') === 'true');
      if (selectedIndex >= 0) return selectedIndex;

      const activeItemIndex = items.findIndex((item) => item.classList.contains('active'));
      if (activeItemIndex >= 0) return activeItemIndex;

      return 0;
    }

    function setActive(index, shouldFocusTab) {
      tabControls.forEach((control, controlIndex) => {
        const isActive = controlIndex === index;
        const navItem = control.closest('li');

        control.setAttribute('aria-selected', isActive ? 'true' : 'false');
        control.tabIndex = isActive ? 0 : -1;
        if (navItem) navItem.classList.toggle('active', isActive);
      });

      items.forEach((item, itemIndex) => {
        const isActive = itemIndex === index;
        const panel = panels[itemIndex];
        const mobileToggle = mobileToggles[itemIndex];

        item.classList.toggle('active', isActive);

        if (panel) {
          panel.hidden = !isActive;
        }

        if (mobileToggle) {
          mobileToggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }
      });

      if (shouldFocusTab && tabControls[index]) {
        tabControls[index].focus();
      }
    }

    tabControls.forEach((control, index) => {
      const navItem = control.closest('li');
      const panel = panels[index];

      if (navItem) navItem.setAttribute('role', 'presentation');
      if (!control.id) control.id = `${root.id}-tab-${index}`;

      control.setAttribute('role', 'tab');
      control.setAttribute('aria-controls', panel.id || `${root.id}-panel-${index}`);

      if (panel) {
        if (!panel.id) panel.id = `${root.id}-panel-${index}`;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('tabindex', '0');
        panel.setAttribute('aria-labelledby', control.id);
      }

      control.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        setActive(index, true);
      }, true);
      control.addEventListener('keydown', (event) => {
        if (!isEnterOrSpace(event)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        setActive(index, true);
      });
    });

    mobileToggles.forEach((mobileToggle, index) => {
      const panel = panels[index];

      if (!mobileToggle || !panel) return;
      if (!mobileToggle.id) mobileToggle.id = `${root.id}-toggle-${index}`;

      mobileToggle.setAttribute('aria-controls', panel.id);

      if (mobileToggle.tagName !== 'BUTTON') {
        mobileToggle.setAttribute('role', 'button');
        mobileToggle.tabIndex = 0;
      }

      const icon = mobileToggle.querySelector('i');
      if (icon) icon.setAttribute('aria-hidden', 'true');

      const labelledBy = panel.getAttribute('aria-labelledby');
      if (labelledBy && !labelledBy.includes(mobileToggle.id)) {
        panel.setAttribute('aria-labelledby', `${labelledBy} ${mobileToggle.id}`);
      }

      mobileToggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        setActive(index);
      }, true);
      mobileToggle.addEventListener('keydown', (event) => {
        if (isEnterOrSpace(event)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setActive(index);
          return;
        }

        const currentIndex = mobileToggles.findIndex((toggle) => toggle === document.activeElement);
        if (currentIndex === -1) return;

        let nextIndex = currentIndex;
        if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % mobileToggles.length;
        if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + mobileToggles.length) % mobileToggles.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = mobileToggles.length - 1;

        if (nextIndex !== currentIndex && mobileToggles[nextIndex]) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setActive(nextIndex);
          mobileToggles[nextIndex].focus();
        }
      });
    });

    tablist.addEventListener('keydown', (event) => {
      const currentIndex = tabControls.findIndex((control) => control === document.activeElement);
      if (currentIndex === -1) return;

      let nextIndex = currentIndex;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabControls.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabControls.length) % tabControls.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabControls.length - 1;

      if (nextIndex !== currentIndex) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setActive(nextIndex, true);
      }
    });

    setActive(getActiveIndex());
  }

  function initPdpTabsSections(scope) {
    const context = scope || document;
    const roots = [];

    if (context.matches && context.matches('.pdp-tabs.product-tabing')) {
      roots.push(context);
    }

    roots.push(...context.querySelectorAll('.pdp-tabs.product-tabing'));
    roots.forEach((root, index) => initPdpTabs(root, index));
  }

  document.addEventListener('DOMContentLoaded', () => initPdpTabsSections(document));
  document.addEventListener('shopify:section:load', (event) => initPdpTabsSections(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-you-may-also-like"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
        $('.product-card .add-to-cart').click(function(e) {
          e.preventDefault();
          var id = $(this).data('id');
          var quantity = 1;
          addToCart(id, quantity);
        });
  
        $('a[href="#login-popup"').click(function(e) {
          e.preventDefault();
          $('#login-popup').fadeIn(200);
        });
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.jQuery) return;

    function enhanceDots(sliderEl) {
      var sectionEl = sliderEl.closest('.slider-section');
      if (!sectionEl) return;

      var dotsEl = sliderEl.querySelector('.slick-dots');
      if (!dotsEl) return;

      var $slider = window.jQuery(sliderEl);
      var slick = $slider.slick('getSlick');
      if (!slick) return;

      var template = sectionEl.getAttribute('data-slider-go-to-slide') || 'Go to slide @num@ of @total@';
      var heading = sectionEl.getAttribute('data-slider-pagination-heading') || 'Slide navigation';
      dotsEl.setAttribute('aria-label', heading);
      dotsEl.setAttribute('role', 'radiogroup');

      var buttons = Array.from(dotsEl.querySelectorAll('button'));
      var total = slick.slideCount;
      if (!total) return;

      buttons.forEach(function (btn, i) {
        var label = String(template).split('@num@').join(String(i + 1)).split('@total@').join(String(total));
        btn.setAttribute('aria-label', label);
        btn.setAttribute('role', 'radio');

        var li = btn.closest('li');
        var isActive = li && li.classList.contains('slick-active');
        if (isActive) {
          btn.setAttribute('aria-checked', 'true');
          btn.setAttribute('aria-current', 'true');
          btn.setAttribute('tabindex', '0');
        } else {
          btn.setAttribute('aria-checked', 'false');
          btn.removeAttribute('aria-current');
          btn.setAttribute('tabindex', '-1');
        }
      });

      if (!sliderEl.__dotsKeyboardNavBound) {
        sliderEl.__dotsKeyboardNavBound = true;

        sliderEl.addEventListener('keydown', function (e) {
          var key = e.key;
          var supported = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
          if (!supported.includes(key)) return;

          var currentDots = sliderEl.querySelector('.slick-dots');
          if (!currentDots) return;

          if (!(e.target && currentDots.contains(e.target))) return;

          var btns = Array.from(currentDots.querySelectorAll('button'));
          if (!btns.length) return;

          var $sliderNow = window.jQuery(sliderEl);
          var slickNow = $sliderNow.slick('getSlick');
          if (!slickNow) return;

          var slideCount = slickNow.slideCount;
          if (!slideCount) return;

          var currentIndex = typeof slickNow.currentSlide === 'number' ? slickNow.currentSlide : 0;

          e.preventDefault();

          var nextIndex = currentIndex;
          if (key === 'Home') nextIndex = 0;
          if (key === 'End') nextIndex = slideCount - 1;
          if (key === 'ArrowLeft' || key === 'ArrowUp') nextIndex = (currentIndex - 1 + slideCount) % slideCount;
          if (key === 'ArrowRight' || key === 'ArrowDown') nextIndex = (currentIndex + 1) % slideCount;

          sliderEl.__pendingDotFocusIndex = nextIndex;
          $sliderNow.slick('slickGoTo', nextIndex);
        });

        sliderEl.addEventListener('focusin', function (e) {
          var currentDots = sliderEl.querySelector('.slick-dots');
          if (!currentDots) return;

          var targetButton = e.target && e.target.closest ? e.target.closest('.slick-dots button') : null;
          if (!targetButton) return;
          if (!currentDots.contains(targetButton)) return;

          var btns = Array.from(currentDots.querySelectorAll('button'));
          var idx = btns.indexOf(targetButton);
          if (idx < 0) return;

          var $sliderNow = window.jQuery(sliderEl);
          var slickNow = $sliderNow.slick('getSlick');
          if (!slickNow) return;

          if (typeof slickNow.currentSlide === 'number' && slickNow.currentSlide !== idx) {
            sliderEl.__pendingDotFocusIndex = idx;
            $sliderNow.slick('slickGoTo', idx);
          }
        });
      }

      if (typeof sliderEl.__pendingDotFocusIndex === 'number') {
        var idx = sliderEl.__pendingDotFocusIndex;
        sliderEl.__pendingDotFocusIndex = null;
        var pendingDots = sliderEl.querySelector('.slick-dots');
        var pendingButtons = pendingDots ? pendingDots.querySelectorAll('button') : null;
        if (pendingButtons && pendingButtons[idx]) {
          pendingButtons[idx].focus();
        }
      }
    }

    var $sliders = window.jQuery('.slider-section .slider');
    if (!$sliders.length) return;

    $sliders.on('reInit afterChange', function () {
      enhanceDots(this);
    });

    $sliders.each(function () {
      var sliderEl = this;

      var tries = 0;
      (function tryEnhance() {
        tries += 1;
        enhanceDots(sliderEl);
        if (!sliderEl.querySelector('.slick-dots') && tries < 25) {
          setTimeout(tryEnhance, 50);
        }
      })();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  function initTabsSection(root) {
    if (!root) return;
    if (root.dataset.tabsInitialized === 'true') return;
    root.dataset.tabsInitialized = 'true';

    const tablist = root.querySelector('.tabs-nav.desktop[role="tablist"]');
    const tabButtons = Array.from(root.querySelectorAll('.tabs-nav.desktop [role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    const mobileToggles = Array.from(root.querySelectorAll('button.mobile[aria-controls]'));
    const mq = window.matchMedia('(max-width: 999px)');

    if (!tablist || tabButtons.length === 0 || panels.length === 0) return;

    let desktopActiveIndex = Math.max(
      0,
      tabButtons.findIndex((t) => t.getAttribute('aria-selected') === 'true')
    );

    function syncDesktopNav(index) {
      tabButtons.forEach((t, i) => {
        const isActive = i === index;
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.tabIndex = 0;
        const li = t.closest('li');
        if (li) li.classList.toggle('active', isActive);
      });
    }

    function setDesktopActive(index, options) {
      const shouldFocus = Boolean(options && options.focus);
      const tab = tabButtons[index];
      const panel = panels[index];
      if (!tab || !panel) return;

      desktopActiveIndex = index;
      syncDesktopNav(index);

      panels.forEach((p, i) => {
        const isActive = i === index;
        p.classList.toggle('active', isActive);
        p.hidden = !isActive;
        p.tabIndex = isActive ? 0 : -1;

        const text = p.querySelector('.text');
        if (text) text.hidden = !isActive;

        const mobileToggle = p.querySelector('button.mobile');
        if (mobileToggle) {
          mobileToggle.tabIndex = -1;
          mobileToggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }
      });

      if (shouldFocus) tab.focus();
    }

    function applyMobileAccordionState() {
      panels.forEach((p) => {
        p.hidden = false;
        p.tabIndex = -1;
        const isActive = p.classList.contains('active');
        const text = p.querySelector('.text');
        if (text) text.removeAttribute('hidden');
        const mobileToggle = p.querySelector('button.mobile');
        if (mobileToggle) {
          mobileToggle.tabIndex = 0;
          mobileToggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }
      });
    }

    function toggleMobileAccordion(panel) {
      const wasActive = panel.classList.contains('active');

      panels.forEach((p) => {
        p.classList.remove('active');
        const mobileToggle = p.querySelector('button.mobile');
        if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
      });

      if (!wasActive) {
        panel.classList.add('active');
        const mobileToggle = panel.querySelector('button.mobile');
        if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
        syncDesktopNav(panels.indexOf(panel));
      }
    }

    function applyLayout() {
      if (mq.matches) {
        applyMobileAccordionState();
      } else {
        setDesktopActive(desktopActiveIndex);
      }
    }

    tabButtons.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        if (!mq.matches) setDesktopActive(index, { focus: true });
      });
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (!mq.matches) setDesktopActive(index, { focus: true });
        }
      });
    });

    tablist.addEventListener('keydown', (e) => {
      if (mq.matches) return;

      const currentIndex = tabButtons.findIndex((t) => t === document.activeElement);
      if (currentIndex === -1) return;

      let nextIndex = currentIndex;
      if (e.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabButtons.length;
      if (e.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabButtons.length) % tabButtons.length;
      if (e.key === 'Home') nextIndex = 0;
      if (e.key === 'End') nextIndex = tabButtons.length - 1;

      if (nextIndex !== currentIndex) {
        e.preventDefault();
        setDesktopActive(nextIndex, { focus: true });
      }
    });

    function activateMobileToggle(btn) {
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) toggleMobileAccordion(panel);
    }

    mobileToggles.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!mq.matches) return;
        activateMobileToggle(btn);
      });

      btn.addEventListener('keydown', (e) => {
        if (!mq.matches) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activateMobileToggle(btn);
        }
      });
    });

    mq.addEventListener('change', applyLayout);
    applyLayout();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.tabs-section').forEach((section) => initTabsSection(section));
  });

  $(document).ready(function() {
    let i = setInterval(function() {
      if (document.querySelector(".cbb-frequently-bought-container")){
          clearInterval(i);
          $('.cbb-frequently-bought-product').each(function() {
            var item = $('.cbb-frequently-bought-selector-list li').eq($(this).index());
            var title = item.find('h3');
            var price = item.find('.cbb-frequently-bought-selector-label-regular-price');
            var price_sale = item.find('.cbb-frequently-bought-selector-label-sale-price');
            var price_compare = item.find('.cbb-frequently-bought-selector-label-compare-at-price');

            var title_html = '';
            if (title.find('span').length) {
              title_html += title.find('span:nth-child(2)').text();
            } else {
              title_html += title.text();
            }

            var compare_html = '';
            if (price_compare.find('.money').length) {
              compare_html += `<div class="price-compare">${price_compare.find('.money').html()}</div>`;
            }

            var price_html = '';
            if (price_sale.find('.money').length) {
              price_html += `<div class="price-compare">${price_sale.find('.money').html()}</div>`;
            } else if (price.find('.money').length) {
              price_html += `<div class="price-compare">${price.find('.money').html()}</div>`;
            }

            $(this).append(`
              <div class="product-info">
                <h3>${title_html}</h3>
                <div class="price">
                  ${compare_html}
                  <div class="price-regular">${price_sale.text()}${price.text()}</div>
                </div>
              </div>`);
          });

          $('.cbb-frequently-bought-form').prepend(`<div class="bundle">Bundle ${$('.cbb-frequently-bought-product').length} Products</div>`);

          $('.cbb-frequently-bought-form').append(`<div class=" info-btn">Money Back Guarantee</div>`);

          $('.cbb-frequently-bought-add-button span').text('Add to Cart');

          $('.cbb-frequently-bought-plus-icon').text('+');

          $('.cbb-frequently-bought-container').append('<a href="/pages/select-bundle" class="link-accent">More Ways to Bundle</a>');

          $(".cbb-frequently-bought-container").insertAfter(".tabs-section");


          $('.cbb-frequently-bought-container').show(0);
      }
    }, 500);
  });

  } catch(e) { console.error(e); }
})();
})();
